const getters = {
  appInfo: (state) => state.app.info,
  appIsReady: (state) => state.app.isReady,
  appStoreSlug: (state) => state.app.slug,
  appStoresList: (state) => state.app.stores,
  appLayout: (state) => state.app.layout,
  cartDetails: (state) => state.cart.details,
  checkoutIntentId: (state) => state.cart.intent_id,
  checkoutClientSecret: (state) => state.cart.client_secret,
  categoriesProductsList: (state) => state.menus.categoriesProducts,
  checkAuth: (state) => state.auth.user !== null,
  checkoutValidation: (state) => state.checkout.validation,
  checkoutComment: (state) => state.checkout.comment,
  flatPayCheckoutData: (state) => state.checkout.flatPayCheckoutData,
  isNewFlatPayMethod: (state) => state.checkout.isNewFlatPayMethod,
  cardInputElement: (state) => state.checkout.cardInputElement,
  darkTheme: (state) => state.settings.darkTheme,
  deliveryDistance: (state) => state.delivery.deliveryDistance,
  deliveryDropoffDateTime: (state) => state.delivery.dropoffDateTime,
  nonDeliverableError: (state) => state.delivery.non_deliverable_error,
  nonDeliverableReason: (state) => state.delivery.non_deliverable_reason,
  deliveryIsAsap: (state) => state.delivery.isAsap,
  deliveryMethod: (state) => state.delivery.deliveryMethod,
  deliveryPrice: (state) => state.delivery.deliveryPrice,
  deliveryTime: (state) => state.delivery.deliveryTime,
  estimatedTime: (state) => state.delivery.estimatedTime,
  deliveryOptionDoor: (state) => state.delivery.optionDoor,
  drawer: (state) => state.settings.drawer,
  guestAddress: (state) => state.guest.guestAddress,
  guestInfo: (state) => state.guest.guestInfo,
  guestSessionId: (state) => state.guest.guestSessionId,
  isAdmin: (state) => state.auth.isAdmin,
  isLoading: (state) => state.loading.isLoading,
  locale: (state) => state.lang.locale,
  locales: (state) => state.lang.locales,
  mainAddonsList: (state) => state.menus.mainAddons,
  optionsAddonsList: (state) => state.menus.optionsAddons,
  ordersList: (state) => state.orders.orders,
  reloadCompanies: (state) => state.companies.reload,
  scheduledOrdersList: (state) => state.orders.scheduledOrders,
  showDrawerMenu: (state) => state.menus.showDrawer,
  storeIdAdmin: (state) => state.storeInfo.storeIdAdmin,
  storeInfo: (state) => state.storeInfo.info,
  storeOnline: (state) => state.storeInfo.online,
  storeMenu: (state) => state.storeInfo.menu,
  token: (state) => state.auth.token,
  user: (state) => state.auth.user,
  sound: (state) => state.sound.status,

  //newthingd
  deliveryServicesList: (state) => state.checkout.deliveryServices,
  paymentOptionsList: (state) => state.checkout.paymentOptions,
  paymentType: (state) => state.checkout.paymentType,
  customerOption: (state) => state.customer.option,
  printer: (state) => state.printer.status,
  offer: (state) => state.checkout.offer,
  addonsProductErrors: (state) => state.discovery.addosErrors,
  selectedTab: (state) => state.discovery.selectedTab,
  total: (state) => state.checkout.total,
  useCredit: (state) => state.checkout.useCredit,
};
export default getters;
